module.exports = __webpack_public_path__ + "assets/share_fb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/share_fb.png
 ** module id = 147
 ** module chunks = 1
 **/